import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { RESET_ALL as RESET_ON_LOGOUT, danger, success } from 'redux-store/reducers/common-reducer';
import { trackEventProfileCreated } from '../../tracking/utils/tracking';

import { API, get, post } from 'utils/api';
import { snakeCaseKeys } from 'utils/keys';
import { createReducer } from 'utils/redux';
import { Querystring } from 'utils/url';
import { __t, applyTranslations } from 'utils/language';
import { logError } from 'utils/log';

applyTranslations(require('./agency-brand-profiles.i18n.json'));

const LOADING_STATE_CHANGED = 'agencyBrandProfiles/LOADING_STATE_CHANGED';
const RECEIVE = 'agencyBrandProfiles/RECEIVE';
const RESET = 'agencyBrandProfiles/RESET';

const { AGENCY } = API.END_POINTS;

const initialState = {
  list: [],
  pagination: {},
  isLoading: false
};

function loadingStateChanged(isLoading) {
  return {
    type: LOADING_STATE_CHANGED,
    payload: {
      isLoading
    }
  };
}

export function resetBrandProfiles() {
  return {
    type: RESET
  };
}

function receiveBrandProfiles(data) {
  return {
    type: RECEIVE,
    payload: {
      data
    }
  };
}

export function createAgencyBrandProfile(agencyId, profileDetails) {
  return dispatch => {
    const url = AGENCY.createBrandProfile(agencyId);
    dispatch(showLoading(url));

    return post(url, { data: profileDetails })
      .then(() => {
        dispatch(hideLoading(url));
        dispatch(success(__t('agency_brand_profiles.save_brand_profile_success')));
        trackEventProfileCreated('brand');
      })
      .catch((error) => {
        dispatch(hideLoading(url));
        if (error.response) {
          dispatch(danger(__t('agency_brand_profiles.save_brand_profile_error')));
        }

        logError(error);
        throw error;
      });
  };
}

export function fetchAgencyBrandsProfiles(agencyId, query = {}) {
  return (dispatch) => {
    const params = snakeCaseKeys({
      itemsPerPage: query.itemsPerPage || window.app.env.PAGINATION_LIMIT,
      page: query.page || 1,
      sort: query.sort
    });

    const queryString = Querystring.objectToString(params);
    const url = `${AGENCY.getBrands(agencyId)}?${queryString}`;

    dispatch(showLoading(url));
    dispatch(loadingStateChanged(true));

    return get(url)
      .then((response) => {
        const brandProfilesData = response.data;

        dispatch(receiveBrandProfiles(brandProfilesData));
        dispatch(loadingStateChanged(false));

        dispatch(hideLoading(url));

        return brandProfilesData;
      })
      .catch(() => {
        dispatch(hideLoading(url));
        dispatch(loadingStateChanged(false));
        dispatch(danger(__t('agency_brand_profiles.loading_failed')));

        return [];
      });
  };
}

export default createReducer('agencyBrandProfiles', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE]: (state, { data }) => ({
    ...state,
    list: data.data,
    pagination: {
      ...data.meta,
      links: data.links
    }
  })
});
